import {
  makeStyles,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@material-ui/core';
import React from 'react';
import Button from './button';
import { DialogTitle } from './modal';
import Text from './text';

export interface ButtonRendererProps {
  onClick: () => any;
}

interface ConfirmModalProps {
  title: string;
  body: string | React.ReactNode;
  successProps: {
    btnLabel: string | React.ReactNode;
    onSuccess: (callback: () => any, event: React.MouseEvent) => any;
  };
  isOpen: boolean;
  onClose: () => void;
  cancelProps?: {
    btnLabel: string | React.ReactNode;
    onCancel?: () => any;
  };
  loading?: boolean;
  children?: React.ReactNode;
  titleIcon?: React.ReactNode;
  classNameTitle?: string;
}

const useStyles = makeStyles({
  paper: {
    width: 480,
  },
  content: {
    padding: '15px 32px 0',
  },
});

function ConfirmModal({
  title,
  body,
  loading,
  successProps,
  isOpen,
  onClose,
  cancelProps,
  children,
  titleIcon,
  classNameTitle,
}: ConfirmModalProps) {
  const classes = useStyles();

  const handleSuccess = (e: React.MouseEvent) => {
    successProps.onSuccess(onClose, e);
  };

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof cancelProps?.onCancel === 'function') {
      cancelProps.onCancel();
    }
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleCancel}
      aria-labelledby='alert-dialog-title'
      PaperProps={{
        className: classes.paper,
        elevation: 3,
      }}>
      <DialogTitle
        id='alert-dialog-title'
        onClose={handleCancel}
        data-testid='dialog-title'
        className={classNameTitle}>
        {title}
        {titleIcon}
      </DialogTitle>
      <DialogContent className={classes.content} data-testid='dialog-content'>
        <Text variant='normal'>{body}</Text>
        {children}
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={handleCancel}
          data-testid='button-cancel'>
          {cancelProps?.btnLabel || 'Cancel'}
        </Button>
        <Button
          onClick={handleSuccess}
          disabled={loading}
          data-testid='button-success'>
          {loading ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            successProps.btnLabel
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmModal;
